/* eslint-disable */
(function() {
  var $ = require('jquery');

  var $tabbedAreas = $('.js-tabbed-area');

  $tabbedAreas.each(function(i, item) {
    var $tabbedArea = $(item),
      $tabs = $('.tabbed-area__tab', $tabbedArea),
      $tabContents = $('.tabbed-area__content', $tabbedArea);

    $tabs.click(function(e) {
      e.preventDefault();

      var target = $(this).data('target'),
        $tab = $tabs.filter(function(i, item) {
          return $(item).data('target') === target;
        });

      $tabs.removeClass('tabbed-area__tab--active');
      $tabContents.removeClass('tabbed-area__content--active');

      $tab.addClass('tabbed-area__tab--active');

      $tabContents
        .filter(function(i, item) {
          return $(item).data('tab') === target;
        })
        .addClass('tabbed-area__content--active');
    });
  });
})();
